export default __webpack_public_path__ + "static/Payroll_Profiles-438bb36d06c2f01529ec8d63fa05d19b.svg";